// extracted by mini-css-extract-plugin
export default {"form__control":"Select_form__control__HcYmo","invalid":"Select_invalid__XkvWi"};